import { bulkReassignAdvisors } from 'common/api/creditApplications';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    SAVE_BULK_REASSING_ADVISOR,
    SAVE_BULK_REASSING_ADVISOR_FAILURE,
    SAVE_BULK_REASSING_ADVISOR_SUCCESS,
} from '../actionTypes';
import { creditsActions } from '../reducer';

import closeModalReassignAdvisor from './closeModalReassignAdvisor';

export default (filterData, values) => (dispatch) => {
    dispatch(creditsActions[SAVE_BULK_REASSING_ADVISOR]());

    bulkReassignAdvisors(values)
        .then(() => {
            dispatch(creditsActions[SAVE_BULK_REASSING_ADVISOR_SUCCESS]());
            dispatch(closeModalReassignAdvisor(filterData));
            if (values.callback) values.callback();
            showToast();
        })
        .catch((error) => {
            dispatch(
                creditsActions[SAVE_BULK_REASSING_ADVISOR_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
